import DataTable from "@/components/Common/DataTable";
import { useMemo, useState } from "react";
import createColumns from "./columns";
import { useReadScenarioApprovals } from "@/libs/react-query/hooks/useScenarioApprovalsQuery";
import { useNavigate } from "react-router-dom";
import { APPROVAL_DIRECTION } from "@/consts/Approval";
import { ScenarioDecision } from "@/consts/Scenario";

export default function ApprovalTable() {
  const navigate = useNavigate();

  const { data } = useReadScenarioApprovals({
    direction: APPROVAL_DIRECTION.REQUESTING,
    pagination: {
      page: 0,
      limit: Number.MAX_SAFE_INTEGER,
    },
    decision_filters: [
      ScenarioDecision.APPROVED,
      ScenarioDecision.REJECTED,
      ScenarioDecision.CANCELED,
      ScenarioDecision.UNDECIDED,
    ],
  });
  const { scenario_approvals: approvals = [] } = data || {};

  const handleRowClick = (projectGroupId: string) => {
    navigate(`/management/projects/${projectGroupId}`);
  };

  const handleTableClick = (approvalId: string) => {
    navigate(`/approvals/${approvalId}`);
  };

  const columns = createColumns({
    onRowClick: (projectGroupId: string) => handleRowClick(projectGroupId),
    onTableClick: (approvalId: string) => handleTableClick(approvalId),
  });

  return (
    <div className="p-5">
      <DataTable
        columns={columns}
        data={approvals}
        isPagination={true}
        tableCellClassName="py-2 px-3"
      />
    </div>
  );
}
